import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "登録方法を選択",
    keyword: "registerMethod",
    type: "radio",
    requiredIcon: true,
    radioPropsList: [
      {
        label: "自身で登録する",
        value: "1",
      },
      {
        label: "代行依頼をする",
        value: "2",
      },
    ],
    setDefaultValue: "1",
  },
];

const schema = {
  registerMethod: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

export { fakeTableList, schema };
